export const Badge = {
  baseStyle: {
    fontWeight: 'semibold',
    width: 'fit-content',
  },
};
